import { render, staticRenderFns } from "./ProcessMenuItem.vue?vue&type=template&id=ab0192aa"
import script from "./ProcessMenuItem.vue?vue&type=script&lang=js"
export * from "./ProcessMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports